/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --font-size: var(--nve-ref-font-size-100);
  width: fit-content;
  display: inline-flex;
  contain: initial;
}

[internal-host] {
  display: flex;
  align-items: center;
}

label {
  color: var(--nve-sys-text-muted-color);
  font-size: var(--nve-ref-font-size-100);
  margin-inline: var(--nve-ref-space-xxs);
  white-space: nowrap;
}

.select-label {
  background: var(--nve-sys-interaction-field-background);
  color: var(--nve-sys-interaction-field-color);
  padding: 0 var(--nve-ref-size-200);
  font-size: var(--font-size);
  position: absolute;
  inset: var(--nve-ref-size-50);
  display: flex;
  place-items: center;
  pointer-events: none;
  text-wrap: nowrap;
  width: fit-content;
}

:host([container='flat']) select,
:host([container='inline']) select {
  opacity: 0;
}

:host([container='flat']) .select-label,
:host([container='inline']) .select-label {
  background: transparent;
}

:host([container='inline']) select {
  opacity: 0;
}

:host([container='inline']) nve-select {
  --width: fit-content;
  margin-inline-end: 0;
}

:host([container='inline']) label {
  margin-inline: 0;
}

nve-input {
  margin-inline-end: var(--nve-ref-space-xs);
  --width: fit-content;
}

nve-select {
  margin-inline-end: var(--nve-ref-space-xs);
  --width: fit-content;
}

nve-icon-button:state(disabled) {
  --nve-sys-interaction-state-ratio-disabled: 0 !important;
}
